import React, { PropsWithChildren } from 'react';

import { ModalProvider } from './ModalContext';
import { LoaderProvider } from './LoaderContext';
import { AlertProvider } from './AlertContext';

function ContextProvider(props: PropsWithChildren<Record<string, unknown>>) {
  return (
    <LoaderProvider>
      <AlertProvider>
        <ModalProvider>{props.children}</ModalProvider>
      </AlertProvider>
    </LoaderProvider>
  );
}

export default ContextProvider;
